import React, { Component } from 'react';
import config from '../../../config';
import common from '../../../common';
import OutsideNotifier from '../../../OutsideNotifier';
import myConfigRoutes from './../../../route-component';
import trackEventsObj from './../../../constants/new-pageTrackEvents'

class TransAndSubs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            enumText: {
                'UT_CRT': {
                    trans: 'createTeam',
                    path: '/create-team',
                    textTrans: '',
                    class: 'si-exhange-icon icon-ucl-transfers',
                    trackEvent: null
                },
                'UT_TRF': {
                    trans: 'manageTeam',
                    path: '/manage-team/{{gamedayid}}',
                    textTrans: 'toMakeTransfer',
                    class: 'si-exhange-icon icon-ucl-transfers',
                    trackEvent: null
                },
                'UT_LIVE': {
                    trans: 'viewTeam',
                    path: '/manage-team/{{gamedayid}}',
                    textTrans: '',
                    class: 'si-exhange-icon icon-ucl-transfers',
                    trackEvent: null
                },
                'UT_SUB': {
                    trans: 'makeSubstitutions',
                    path: '/manage-team/{{gamedayid}}',
                    textTrans: 'toMakesubstitutions',
                    class: 'si-exhange-icon icon-ucl-transfers',
                    trackEvent: null
                }
            },
            objDuration: null
        }
    }
    componentDidMount() {

    }

    onRedirectTo(sPath, trackEvent) {
        let gamedayId = this.props.gamedayId;
        let enumText = this.state.enumText;
        let objText = enumText[this.props.enumUserScinarioCode];
        // let trackEvent = objText.trackEvent;
        if (objText) {
            if (trackEvent) {
                common.customTracking(trackEvent);
            }
            sPath = objText.path.replace('{{gamedayid}}', gamedayId);
            this.props.onRedirectTo(sPath);
        }
    }

    callTracking = () => {
        //find the obj 
        const rulesObj = myConfigRoutes.find((obj) => {
            return obj.name == 'rules'
        })
        const article_id = {
            rules: {
                en: "2396425",
                es: "2396430",
                fr: "2396426",
                de: "2396431",
                it: "2396427",
                pt: "2396428",
                ru: "2396429"
            },
        }

        if (rulesObj) {
            // var url = rulesObj.url.replace(
            //     '{{ARTICLE_ID}}',
            //     article_id['rules'][config.CURRENT_LANGUAGE]
            // )
            var url = config.article_id['rules'][config.CURRENT_LANGUAGE].replace(
              '{{boolean}}',
              config.isMobile ? 'true' : 'false'
            )
            common.pageViewTracking(rulesObj.url, trackEventsObj['rules']);
            window.open(url);
        }


    }




    render() {
        let trans = this.props.trans;
        let isAccounting = this.props.isAccounting;
        if (isAccounting === "" || isAccounting == 2 || isAccounting == null || isAccounting == undefined) {
            return null
        } else {
            if (isAccounting == 0) {
                //subs markup
                return (<div className="si-card si-card__eot si-restart">
                    <div className="si-card__eot-ct">
                        <div className="si-mt-text-title">
                            { trans.newSubsHeader
                                ? trans.newSubsHeader
                                : "Get your team ready for the restart!" }

                        </div>
                        <div className="si-text-descp">
                            { trans.newSubsDescp
                                ? trans.newSubsDescp + " "
                                : "Check your team to see if you need to make subs or change captain. After the last 16, you’ll get unlimited transfers for the quarter-finals. For more details " + " " }<a onClick={ () => { this.callTracking() } }>{ trans.readRules ? trans.readRules : "read the rules." }</a>
                        </div>

                        <div className="button-block" onClick={ () => {
                            common.customTracking('Fantasy Football - Leagues');

                            this.onRedirectTo('/create-team', 'Leagues Card New')
                        } }>
                            <div className="si-btn btn-lg"> { trans.makeSubstitutions
                                ? trans.makeSubstitutions
                                : "Make substitutions" }</div>
                        </div>
                    </div>
                </div>)

            } else if (isAccounting == 1) {
                //transfers markup 
                return (<div className="si-card si-card__eot">
                    <div className="si-card__eot-ct">
                        <div className="si-mt-text-title">
                            { trans.newTransferHeader
                                ? trans.newTransferHeader
                                : "Unlimited free transfers now open" }

                        </div>
                        <div className="si-text-descp">
                            { trans.newTransferDescp
                                ? trans.newTransferDescp
                                : "Want to finish the season in style? Make as many free transfers as you like before the quarter-finals kick off!" }
                        </div>

                        <div className="button-block" onClick={ () => {
                            common.customTracking('Fantasy Football - Leagues');

                            this.onRedirectTo('/create-team')
                        } }>
                            <div className="si-btn btn-lg"> { trans.newMakeTransfers
                                ? trans.newMakeTransfers
                                : "Make Transfers" }</div>
                        </div>
                    </div>
                </div>)

            } else {
                return null
            }

        }


    }
}

export default TransAndSubs;


// WEBPACK FOOTER //
// ./src/components/home/cards/TransAndSubs.js